import { createContext, useContext } from 'react';

import { mediaSize, panelType } from '~/src/dash/components/layout/common';
import { fontColorType } from '~/src/dash/components/text/common';

interface IPanelContext {
  type: panelType;
  colors: Record<string, string>;
  fontColors: Record<fontColorType, string>;
  theme: Record<string, string>;
  width?: number;
  height?: number;
  panelSize?: mediaSize;
}

export const PanelContext = createContext({} as IPanelContext);

export const usePanel = () => useContext(PanelContext);
